import {Route, Routes} from "react-router-dom";
import OrderList from "./OrderList";
import RequireAuth from "../../components/RequireAuth";
import {PermissionLevel} from "../../app/api/model/user";
import OrderDetails from "./Detail/OrderDetails";

export default function Orders() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.VIEW_ONLY}>
            <Routes>
                <Route index element={<OrderList />} />
                <Route path=":orderId" element={<OrderDetails />} />
            </Routes>
        </RequireAuth>
    );
}
